module.exports = __webpack_public_path__ + "static/media/capture-bg.ef1e6649.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/capture-bg.png
// module id = 179
// module chunks = 0